import { BaseService } from './BaseService';
import { ConfigApi } from '../config/Constantes';
import { geraFiltroHttp } from '../util/functions';

class ModuloService extends BaseService {
  constructor() {
    super(`${ConfigApi.moduloURL}`);
  }

  async findBySistemaEdicao(idSistema, codigoEdicao) {
    this.setLoading(true);
    try {
      const filterGet = geraFiltroHttp({ idSistema, codigoEdicao: `${codigoEdicao}` });
      const response = await this.api.get(`${this.url}/sistema/edicao${filterGet}`);
      return response.data;
    } finally {
      this.setLoading(false);
    }
  }

  getFilter() {
    return new Filter();
  }
}

class Filter {
  constructor() {
    this.limit = 11;
    this.page = 0;
  }
}

export default new ModuloService();
